import { render, staticRenderFns } from "./ModalCriarPaciente.vue?vue&type=template&id=4e8d51e0&scoped=true"
import script from "./ModalCriarPaciente.vue?vue&type=script&lang=ts"
export * from "./ModalCriarPaciente.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarPaciente.vue?vue&type=style&index=0&id=4e8d51e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d51e0",
  null
  
)

export default component.exports